"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateRoleAclDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
class UpdateRoleAclDto {
}
exports.UpdateRoleAclDto = UpdateRoleAclDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [Number] }),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsInt)({ each: true }),
    tslib_1.__metadata("design:type", Array)
], UpdateRoleAclDto.prototype, "aclIds", void 0);
